import React from "react";

import { Modal } from "@shared/components";
import { useTranslate } from "@refinedev/core";

import { SubscriptionForm } from "../SubscriptionForm";
import { CreateSubscriptionModalProps } from "./types";
import { useCreateSubscriptionModal } from "./controller";

export const CreateSubscriptionModal = React.memo(
  ({ modalRef, onComplete }: CreateSubscriptionModalProps) => {
    const translate = useTranslate();

    const { methods, mutateAsync, isPending } = useCreateSubscriptionModal(
      modalRef,
      onComplete
    );

    return (
      <Modal
        ref={modalRef}
        title={translate("subscription_admin.titles.create")}
        onConfirm={mutateAsync}
        methods={methods}
        isPending={isPending}
      >
        <SubscriptionForm multiplePlans />
      </Modal>
    );
  }
);
